export default __webpack_public_path__ + "49b26e431fcf76a647d33d447bfb7930.mov";